/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row4_CostInputs */

const en_mk_model_row4_cost = /** @type {(inputs: Mk_Model_Row4_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp900/search`)
};

const id_mk_model_row4_cost = /** @type {(inputs: Mk_Model_Row4_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp900/pencarian`)
};

/**
* | output |
* | --- |
* | "≈ Rp900/search" |
*
* @param {Mk_Model_Row4_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row4_cost = /** @type {((inputs?: Mk_Model_Row4_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row4_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row4_cost(inputs)
	return en_mk_model_row4_cost(inputs)
});